import moment from 'moment';
import { enqueueSnackbar } from '../store/actions/notificationActionCreator';
import store from '../store/configureStore';
import { ScreenActionSet, ScreentPermissionSet } from './permissions';
import { persistor } from '../store/configureStore';

export const ConsoleAction = (isDisable) => {
    if (isDisable)
        Object.keys(console).forEach((key) => {
            console[key] = () => {};
        });
};

export function isVideoURL(url) {
    // List of common video file extensions
    const videoExtensions = [
        '.mp4',
        '.avi',
        '.mkv',
        '.mov',
        '.wmv',
        '.flv',
        '.webm',
    ];

    // Convert the URL to lowercase for case-insensitive matching
    const lowercaseURL = url.toLowerCase();

    // Check if the URL ends with any of the video extensions
    for (const extension of videoExtensions) {
        if (lowercaseURL.endsWith(extension)) {
            return true; // URL points to a video
        }
    }

    return false; // URL is not a video
}

export function checkHttpStatus(status, hideNotify) {
    switch (status?.code) {
        case 403:
        case 400:
        case 429:
            if (!hideNotify) {
                store.dispatch(
                    enqueueSnackbar({
                        message: `${status?.message}`,
                        options: {
                            key: new Date().getTime() + Math.random(),
                            variant: 'error',
                        },
                    }),
                );
            }
            return false;
        case 401:
            if (!hideNotify)
                store.dispatch(
                    enqueueSnackbar({
                        message: `${status?.message}`,
                        options: {
                            key: new Date().getTime() + Math.random(),
                            variant: 'error',
                        },
                    }),
                );
            // AuthenticationService.logoutUser();
            logout();
            return false;
        case 501:
            // store.dispatch(
            //     enqueueSnackbar({
            //         message: `${status?.message}`,
            //         options: {
            //             key: new Date().getTime() + Math.random(),
            //             variant: 'error',
            //         },
            //     }),
            // );
            // AuthenticationService.logoutUser();
            return false;
        case 500:
        case 503:
            if (!hideNotify)
                store.dispatch(
                    enqueueSnackbar({
                        message: `${status?.message}`,
                        options: {
                            key: new Date().getTime() + Math.random(),
                            variant: 'error',
                        },
                    }),
                );
            return false;
        case 200:
        case 201:
        case 202:
            return true;
        default:
            return false;
    }
}

export const GetInitalLetters = (str) => {
    if (!str) return null;
    const strArr = str.split(' ');
    if (strArr.length === 1) {
        return `${strArr[0][0]?.toUpperCase()}`;
    }
    return `${strArr[0][0]?.toUpperCase()}${strArr[
        strArr.length - 1
    ][0]?.toUpperCase()}`;
};

/**
 *
 * @param {*} num
 * @param {
 *    maximumFractionDigits: number,
 *    style: type (default: 'currency'),
 *    currency: currency code (default: 'INR')
 * } opt
 */
export function formatCurrency(num, opt = null) {
    let options = {
        style: 'currency',
        currency: 'INR',
    };
    if (opt) {
        options = {
            ...options,
            ...opt,
        };
    }
    if (!num) num = 0;
    return num.toLocaleString('en-IN', options);
}

export function getLoginUser() {
    return localStorage.getItem('USER_INFO')
        ? JSON.parse(window.atob(localStorage.getItem('USER_INFO')))
        : '';
}
export function getLoginOrg() {
    return localStorage.getItem('ORG_INFO')
        ? JSON.parse(window.atob(localStorage.getItem('ORG_INFO')))
        : '';
}
export function getUserToken() {
    return localStorage.getItem('USER_INFO')
        ? JSON.parse(window.atob(localStorage.getItem('USER_INFO')))?.token
        : '';
}
export function getStoreState() {
    return localStorage.getItem('state')
        ? JSON.parse(window.atob(localStorage.getItem('state')))?.token
        : '';
}

export function logout() {
    localStorage.clear();
    persistor?.purge();
    window.location.href = '/';
}

export const dateTimeToMilliseconds = (date, time) => {
    console.log('date', date);
    console.log('time', time);
    return moment(moment(date).format('YYYY-MM-DD'))
        .set('hour', moment(time).format('H'))
        .set('minute', moment(time).format('mm'))
        .valueOf();
};

export const capitalize = (str) => {
    return str[0].toUpperCase() + str.substring(1, str.length);
};

/**
 * Interpolate `{{token}}` placeholders in a template string using a values map.
 * Tokens with no matching key are left untouched, so partial maps are safe.
 * @param {string} template e.g. "Signed by {{vendorName}}"
 * @param {Record<string, string|number>} [placeholders] e.g. { vendorName: 'Bangalore City' }
 * @returns {string}
 */
export const replacePlaceholders = (template = '', placeholders = {}) =>
    String(template).replace(/\{\{\s*(\w+)\s*\}\}/g, (token, key) =>
        Object.prototype.hasOwnProperty.call(placeholders ?? {}, key)
            ? String(placeholders[key])
            : token,
    );

export function getFileExtension(filename) {
    // get file extension
    const extension = filename.split('.').pop();
    return extension;
}

export function getFilename(filename) {
    // get file extension
    const lastDotIndex = filename.lastIndexOf('.');
    return lastDotIndex > 0 ? filename.substring(0, lastDotIndex) : filename;
}

export function isEmpty(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean') return false;
    if (obj == null) return true;
    if (obj instanceof Date) {
        return isNaN(obj);
    }
    if (obj instanceof Set) {
        return obj.size === 0;
    }
    //if (typeof obj[index] === "undefined" && obj[index] === null) return true;
    if (obj.length === 0) return true;
    if (obj.length > 0) return false;
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}

export function findArrayObjectIndex(key, value, array, path, dataType) {
    if (!isEmpty(array)) {
        for (var arrayIndex in array) {
            var a = array[arrayIndex];
            if (path) {
                for (var i = 0; i < path.length; i++) {
                    if (a && typeof a == 'object') {
                        a = a[path[i]];
                    }
                }
            }
            if (dataType == 'date') {
                console.log(
                    '(new Date(a[key])).getTime()',
                    new Date(a[key]).getTime(),
                );
                console.log(
                    '(new Date(value)).getTime()',
                    new Date(value).getTime(),
                );
                if (
                    a &&
                    typeof a == 'object' &&
                    new Date(a[key]).getTime() == new Date(value).getTime()
                )
                    return arrayIndex;
            } else {
                if (a && typeof a == 'object' && a[key] == value)
                    return arrayIndex;
            }
        }
    }
}

export function JSONTOCSVFormat(
    JSONData,
    ReportTitle,
    ShowLabel,
    twoLineHeader,
) {
    let arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    let CSV = '';
    if (ReportTitle) CSV += ReportTitle + '\r\n\n';
    // else CSV += '\r\n\n';
    if (ShowLabel) {
        let row = '';
        let row1 = '';
        let isTwoHeader = false;
        if (twoLineHeader) {
            for (let index in arrData[0]) {
                if (typeof arrData[0][index] === 'object') {
                    isTwoHeader = true;
                    for (let index1 in arrData[0][index]) {
                        row += index + ',';
                        row1 += index1 + ',';
                    }
                } else {
                    row += index + ',';
                    row1 += index + ',';
                }
            }
            row = row.slice(0, -1);
            CSV += row + '\r\n';
            if (isTwoHeader) {
                row1 = row1.slice(0, -1);
                CSV += row1 + '\r\n';
            }
        } else {
            for (let index in arrData[0]) {
                row += index + ',';
            }
            row = row.slice(0, -1);
            CSV += row + '\r\n';
        }
    }
    if (twoLineHeader) {
        for (let i = 0; i < arrData.length; i++) {
            let row = '';
            for (let index in arrData[i]) {
                if (typeof arrData[0][index] === 'object') {
                    for (let index1 in arrData[i][index]) {
                        row += '"' + arrData[i][index][index1] + '",';
                    }
                } else {
                    row += '"' + arrData[i][index] + '",';
                }
            }
            row.slice(0, row.length - 1);
            CSV += row + '\r\n';
        }
    } else {
        for (let i = 0; i < arrData.length; i++) {
            let row = '';
            for (let index in arrData[i]) {
                row += '"' + arrData[i][index] + '",';
            }
            row.slice(0, row.length - 1);
            CSV += row + '\r\n';
        }
    }

    if (CSV === '') {
        alert('Invalid data');
        return;
    }
    return CSV;
}

export function JSONToCSVConvertor(
    fileName,
    JSONData,
    ReportTitle,
    ShowLabel,
    twoLineHeader,
) {
    let CSV = JSONTOCSVFormat(JSONData, ReportTitle, ShowLabel, twoLineHeader);
    // fileName += ReportTitle.replace(/ /g, '_');
    let uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
    let link = document.createElement('a');
    link.href = uri;
    link.style = 'visibility:hidden';
    link.download = fileName + '.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function downloadJsonData(data, fileName) {
    const dataStr =
        'data:text/json;charset=utf-8,' +
        encodeURIComponent(JSON.stringify(data));
    this.downloadData(dataStr, fileName);
}

export function downloadData(dataStr, fileName) {
    const dlAnchorElem = document.createElement('a');
    dlAnchorElem.setAttribute('href', dataStr);
    dlAnchorElem.setAttribute('download', fileName);
    dlAnchorElem.click();
}

export function newMoment(dateLike, format) {
    return moment(dateLike, format);
}

export function newDateMoments(dateLike, format) {
    return newMoment(dateLike, format).toDate();
}

export function vehicleTemp(obj) {
    if (
        !isEmpty(obj) &&
        !isEmpty(obj.temperature) &&
        obj.temperature != '3000' &&
        obj.temperature != '85' &&
        obj.temperature != '200'
    ) {
        return obj.temperature + ' Celsius';
    } else {
        return 'N/A';
    }
}

export function getTimeDifference(date1, date2, timeFormat) {
    var timeDifference = Math.abs(
        newDateMoments(date1) - newDateMoments(date2),
    );
    if (timeFormat == 'seconds' || timeFormat == 's') {
        return timeDifference / 1000;
    } else if (timeFormat == 'minutes' || timeFormat == 'm') {
        return timeDifference / (1000 * 60);
    } else if (timeFormat == 'hours' || timeFormat == 'h') {
        return timeDifference / (1000 * 60 * 60);
    } else {
        return timeDifference;
    }
}
export function getTimeAsDuration(time, format, returnFormat) {
    var formatMapper = {
        small: {
            days: 'd',
            hours: 'h',
            mins: 'm',
        },
        long: {
            days: 'days',
            hours: 'hours',
            mins: 'mins',
        },
    };

    time = Math.abs(time);
    format = format || 'long';
    /**
     * Need isEmpty since 0 could be ignored when just using !
     **/
    if (isEmpty(time)) {
        return '';
    }
    if (time <= 0) {
        return '<1' + formatMapper[format]['mins'];
    }

    var days = Math.floor(time / (60 * 60 * 24 * 1000));
    var hours = Math.floor((time % (60 * 60 * 24 * 1000)) / (60 * 60 * 1000));
    var mins = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000));

    var retStr = '';
    if (!isEmpty(returnFormat) && returnFormat == 'dh') {
        if ((isEmpty(days) || days <= 0) && (isEmpty(hours) || hours <= 0)) {
            retStr = mins ? mins + formatMapper[format]['mins'] + ' ' : '';
        } else {
            retStr =
                (days ? days + formatMapper[format]['days'] + ' ' : '') +
                (hours ? hours + formatMapper[format]['hours'] + ' ' : '');
        }
    } else {
        retStr =
            (days ? days + formatMapper[format]['days'] + ' ' : '') +
            (hours ? hours + formatMapper[format]['hours'] + ' ' : '') +
            (mins ? mins + formatMapper[format]['mins'] + ' ' : '');
    }
    if (isEmpty(retStr)) {
        return '<1' + formatMapper[format]['mins'];
    } else {
        return retStr;
    }
}

export const showMessage = (msg, type) => {
    store.dispatch(
        enqueueSnackbar({
            message: `${msg}`,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: type,
            },
        }),
    );
};

// Formats the dual-partner /org/ev/block response (EvBlockResponse) into a
// snackbar message + variant. Both energy and IoT partners are attempted;
// success on either is an overall success, mixed results surface as a warning.
export const formatEvBlockResult = (resp) => {
    const ok = resp?.status?.code == 200;
    const body = resp?.response;

    if (!body || (!body.energyAttempted && !body.iotAttempted)) {
        return {
            message: resp?.status?.message || (ok ? 'Done' : 'Failed'),
            variant: ok ? 'success' : 'error',
        };
    }

    const lines = [];
    if (body.energyAttempted) {
        lines.push(
            `Energy: ${body.energySuccess ? '✓ success' : '✗ failed'}${
                body.energyMessage ? ` — ${body.energyMessage}` : ''
            }`,
        );
    }
    if (body.iotAttempted) {
        lines.push(
            `IoT: ${body.iotSuccess ? '✓ success' : '✗ failed'}${
                body.iotMessage ? ` — ${body.iotMessage}` : ''
            }`,
        );
    }

    const bothAttempted = body.energyAttempted && body.iotAttempted;
    const allSucceeded =
        (!body.energyAttempted || body.energySuccess) &&
        (!body.iotAttempted || body.iotSuccess);

    let variant = 'error';
    if (body.overallSuccess) {
        variant = bothAttempted && !allSucceeded ? 'warning' : 'success';
    }

    return { message: lines.join('   •   '), variant };
};
export const filterArrayEmptyValue = (arrayWithEmptyValues) => {
    return !!arrayWithEmptyValues?.length
        ? arrayWithEmptyValues.filter(function (value) {
              // Keep only non-empty values
              return (
                  value !== '' &&
                  value !== ' ' &&
                  value !== null &&
                  value !== undefined
              );
          })
        : [];
};

export const canAllow = (screen, action) => {
    const configs = store.getState().user.config;
    const permission = configs.permission ?? {};
    const pScreen =
        ScreentPermissionSet[screen?.replace(' ', '_')?.toUpperCase()];

    return (
        permission.hasOwnProperty(pScreen) &&
        permission[pScreen]?.includes(action)
    );
};
export const isSuperAdmin = () => {
    const role = store?.getState()?.user?.role;
    const superAdminRoles = [
        9,
        '9',
        15,
        '15',
        16,
        '16',
        17,
        '17',
        18,
        '18',
        22,
        '22',
        '34',
        35,
        '35',
        34,
    ];
    return superAdminRoles.includes(role);
};
export const isSuperAdminOrAdmin = () => {
    const role = store?.getState()?.user?.role;
    const superAdminOrAdminRoles = [9, '9'];
    return superAdminOrAdminRoles.includes(role);
};

export const getActiveInitRoute = () => {
    let routes = Object.values(ScreentPermissionSet);
    let activeRoute = null;
    for (let item of routes) {
        const permission = getPermissions(item);
        if (permission.read) {
            activeRoute = item?.replaceAll('_', '-');
            break;
        }
    }
    return activeRoute ?? '404';
};

const DEFAULT_PERMISSIONS = Object.freeze({
    read: true,
    update: true,
    create: true,
    delete: true,
    auth: true,
});

export const getPermissions = (screen) => {
    // console.log(screen, {
    //     read: canAllow(screen, ScreenActionSet.READ),
    //     update: canAllow(screen, ScreenActionSet.UPDATE),
    //     create: canAllow(screen, ScreenActionSet.CREATE),
    //     delete: canAllow(screen, ScreenActionSet.DELETE),
    // });
    // if (screen == 'Control center')
    //     return {
    //         read: true,
    //         update: true,
    //         create: true,
    //         delete: true,
    //         auth: true,
    //     };

    const normalizedScreen = screen?.replace(' ', '_')?.toUpperCase();
    const pScreen = ScreentPermissionSet[normalizedScreen];

    if (!pScreen) {
        return DEFAULT_PERMISSIONS;
    }
    return {
        read: canAllow(screen, ScreenActionSet.READ),
        update: canAllow(screen, ScreenActionSet.UPDATE),
        create: canAllow(screen, ScreenActionSet.CREATE),
        delete: canAllow(screen, ScreenActionSet.DELETE),
        auth: canAllow(screen, ScreenActionSet.AUTH),
        allowStaffDelete: canAllow(screen, ScreenActionSet.ALLOW_STAFF_DELETE),
    };
};

export const getZappayAuthToken = () => {
    return store.getState().user?.config?.zappayAuthToken ?? null;
};

export const getShadowIp = () => {
    return store.getState().user?.config?.shadowIP ?? null;
};

/**
 * Builds the shadowIP request config (payload fragment) for a Zappay endpoint.
 *
 * Used to mirror a request to the shadowIP address in parallel with the
 * original call. The request is routed as a third-party call - the middleware
 * hits the absolute `url` as-is (no ZAPPAY_API_URL prefix) and forwards the
 * auth token via `overwriteHeaders`.
 *
 * Returns `null` when no shadowIP is configured, so callers can skip the
 * mirrored call entirely.
 *
 * @param {string} path - relative path, e.g. `/user/payment-indents`
 * @returns {object|null} payload fragment to spread into an API action payload
 */
export const generateShadowEndpoint = (path) => {
    const shadowIp = getShadowIp();
    if (!shadowIp) return null;

    const normalizedPath = path?.startsWith('/') ? path : `/${path}`;
    const base = String(shadowIp).replace(/\/+$/, '');
    const url = /^https?:\/\//i.test(base)
        ? `${base}${normalizedPath}`
        : `http://${base}${normalizedPath}`;

    return {
        url,
        thirdParty: true,
        overwriteHeaders: { authtoken: getZappayAuthToken() },
    };
};

export const replaceTextWithCapsAndUnderscore = (text) => {
    return text?.toUpperCase()?.replace(/ /g, '_') ?? null;
};
export function isFunction(functionToCheck) {
    return (
        functionToCheck &&
        {}.toString.call(functionToCheck) === '[object Function]'
    );
}
export function sortByMultipleProperties(
    array = [],
    sortProperties,
    order = 'asc',
    caseSensitive = false,
) {
    if (!array) return [];

    return array?.sort((a, b) => {
        for (const prop of sortProperties) {
            // const comparison = caseSensitive
            //     ? a?.[prop]?.localeCompare(b?.[prop])
            //     : a?.[prop]
            //           ?.toLowerCase()
            //           ?.localeCompare(b?.[prop]?.toLowerCase());
            const comparison = 0;
            if (a[prop] === '' && b[prop] !== '') return 1;
            if (a[prop] !== '' && b[prop] === '') return -1;
            if (a[prop] < b[prop]) return -1;
            if (a[prop] > b[prop]) return 1;
            //a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0;
            // if (comparison !== 0) {
            //     return order === 'asc' ? comparison : -comparison;
            // }
        }
        return 0;
    });
}

export function callPhoneNumber(number) {
    let phoneNumber = number?.replace('+91', '').trim();
    if (!!phoneNumber && phoneNumber?.length === 10) {
        //alert(phoneNumber);
        // Create an anchor element
        const anchor = document.createElement('a');
        // Set the href attribute to initiate a phone call
        anchor.href = `tel:+91${phoneNumber}`;
        // Append the anchor to the body
        document.body.appendChild(anchor);
        // Programmatically click the anchor tag to initiate the call
        anchor.click();
        // Remove the anchor from the DOM
        document.body.removeChild(anchor);
    }
}
export function groupBy(array, key) {
    return array.reduce((result, currentValue) => {
        // Get the value of the key to group by
        const groupKey = currentValue[key];

        // Check if the key already exists in the result object
        if (!result[groupKey]) {
            // If not, create an array for that key
            result[groupKey] = [];
        }

        // Push the current object into the respective key's array
        result[groupKey].push(currentValue);

        return result;
    }, {});
}

// Function to mask the mobile number
export const getMaskedNumber = (number) => {
    return number?.replace(/(\d{0})\d{6}(\d{4})/, '$1****$2') ?? '';
};

export const weekDays = [
    { index: 0, name: 'Sunday', shortName: 'Sun', color: '#FF5733' },
    { index: 1, name: 'Monday', shortName: 'Mon', color: '#FFC300' },
    { index: 2, name: 'Tuesday', shortName: 'Tue', color: '#36A2EB' },
    { index: 3, name: 'Wednesday', shortName: 'Wed', color: '#8E44AD' },
    { index: 4, name: 'Thursday', shortName: 'Thu', color: '#2ECC71' },
    { index: 5, name: 'Friday', shortName: 'Fri', color: '#E74C3C' },
    { index: 6, name: 'Saturday', shortName: 'Sat', color: '#3498DB' },
];

export const getWeekDaysFromRoster = (rosterDays) => {
    if (!rosterDays) return []; // Handle empty or null case

    const dayIndexes = rosterDays.split(',').map(Number); // Convert to number array
    return dayIndexes.map((index) =>
        weekDays.find((day) => day.index === index),
    );
};

/**
 * Creates a list of week objects with start and end dates
 * @param {boolean} includeNextWeeks - Feature flag to include next 10 weeks
 * @param {boolean} includeCurrentWeek - Flag to include current week in the list
 * @returns {Array} Array of week objects with start and end dates
 */
export function createWeeksList(
    includeNextWeeks = false,
    includeCurrentWeek = false,
) {
    const weeks = [];

    // Determine the starting point based on includeCurrentWeek flag
    // If we want to include current week: go from 9 weeks ago to 0 (current)
    // If we want to exclude current week: go from 10 weeks ago to 1 (last week)
    const startWeekOffset = includeCurrentWeek ? 9 : 10;
    const endWeekOffset = includeCurrentWeek ? 0 : 1;

    // Get past weeks (with or without current week)
    for (let i = startWeekOffset; i >= endWeekOffset; i--) {
        const startOfWeek = moment().subtract(i, 'weeks').startOf('isoWeek'); // isoWeek uses Monday as start

        const endOfWeek = moment().subtract(i, 'weeks').endOf('isoWeek');

        weeks.push({
            weekNumber: weeks.length + 1,
            startDate: startOfWeek.format('YYYY-MM-DD'),
            endDate: endOfWeek.format('YYYY-MM-DD'),
            value: endOfWeek.format('YYYY-MM-DD'),
            startDateFormatted: startOfWeek.format('MMM DD, YYYY'),
            endDateFormatted: endOfWeek.format('MMM DD, YYYY'),
            label: `Week of ${startOfWeek.format(
                'MMM DD',
            )} to ${endOfWeek.format('MMM DD')}`,
            isCurrent: i === 0,
        });
    }

    // Add next 10 weeks if feature is enabled
    if (includeNextWeeks) {
        for (let i = 1; i <= 10; i++) {
            const startOfWeek = moment().add(i, 'weeks').startOf('isoWeek');

            const endOfWeek = moment().add(i, 'weeks').endOf('isoWeek');

            weeks.push({
                weekNumber: weeks.length + 1,
                startDate: startOfWeek.format('YYYY-MM-DD'),
                endDate: endOfWeek.format('YYYY-MM-DD'),
                value: endOfWeek.format('YYYY-MM-DD'),
                startDateFormatted: startOfWeek.format('MMM DD, YYYY'),
                endDateFormatted: endOfWeek.format('MMM DD, YYYY'),
                label: `Week of ${startOfWeek.format(
                    'MMM DD',
                )} to ${endOfWeek.format('MMM DD')}`,
                isCurrent: false,
            });
        }
    }

    return weeks;
}
